import $ from 'jquery';

const blog = function blog() {
  const $filtersToggle = $('#filters-toggle');
  const $filters = $('.blog-filters--items');

  if ($filtersToggle && $filtersToggle.length) {
    $filtersToggle.click(() => {
      $filters.slideToggle();
    });
  }
};
export default blog;



// WEBPACK FOOTER //
// ./src/scripts/modules/blog.js